import { Grid, Typography, Paper, Box, Button, TextField, MenuItem } from "@mui/material";
import { useState } from "react";
import { NumericFormat } from "react-number-format";
import { crearPlanPersonalizadoAPI } from "../../services/companyAPI";
import LoadingComponent from "../../../widgets/LoadingComponent";
import moment from "moment";
import auditoriaSet from "../../../widgets/Auditoria";
import { getData, postData } from "../../../api/ApiRest";

const inputSx = {
  '& .MuiInputBase-input': { fontSize: '0.82rem' },
  '& .MuiInputLabel-root': { fontSize: '0.82rem' },
};

const sectionTitleSx = {
  fontWeight: 700, fontSize: '0.82rem', px: 1.5, py: 0.8,
  borderRadius: 1, background: '#224B6A', color: '#fff', letterSpacing: 0.3,
  mb: 1.5, display: 'block',
};

const PlanPersonalizado = ({
  closeWindow,
  CompanyId,
  ultimoPlanActivo,
  // esNuevoPlanPadre = false,
}) => {
  const [planPersonalizado, setPlanPersonalizado] = useState({
    CompanyId,
    PlanId: 23,
  });

  const [loading, setLoading] = useState(false);

  const onChangeValuePlan = (event) => {
    const { value, name } = event.target;

    if (
      name === "ValorTotalPlan" ||
      name === "FoliosCantidad" ||
      name === "ValorUnidadFolio"
    ) {
      setPlanPersonalizado({ ...planPersonalizado, [name]: Number(value) });
      return;
    }

    if (name === "esNuevoPlanPadre") {
      if (value === "false") {
        planPersonalizado.FechaInicio = moment(ultimoPlanActivo.finRenovacion)
          .add(1, "days")
          .format("yyyy-MM-DD");
      }
    }

    setPlanPersonalizado({ ...planPersonalizado, [name]: value });
  };

  const crearPlanPersonalizado = async (event) => {
    event.preventDefault();

    setLoading(true);
    const result = await crearPlanPersonalizadoAPI(
      planPersonalizado.esNuevoPlanPadre,
      planPersonalizado.CompanyId,
      planPersonalizado.PlanId,
      planPersonalizado.FacturaFecha,
      planPersonalizado.FacturaNumero,
      planPersonalizado.FacturaPrefijo,
      planPersonalizado.FechaInicio,
      planPersonalizado.FoliosCantidad,
      planPersonalizado.Observacion,
      planPersonalizado.PagoAnual,
      planPersonalizado.ValorUnidadFolio
    );

    auditoriaSet(planPersonalizado, {}, 'C', 'Empresa', planPersonalizado.CompanyId, 'Planes');

    setTimeout(() => {
      if (result.status)
        window.location.reload();
    }, 500);

    setLoading(false);
    return result;
  };

  const onChangeFechaInicio = (event) => {
    const { value } = event.target;
    if (planPersonalizado.esNuevoPlanPadre === "true") {
      planPersonalizado.FechaInicio = value;
    }
  };

  const generarFactura = () => {
    setLoading(true);

    getData('api/Configuracion/Factura/generarFactura', {
      Cliente: planPersonalizado.CompanyId,
      Fecha: new Date().toISOString().split('T')[0],
      PlanId: planPersonalizado.PlanId,
      prefijo: planPersonalizado.FacturaPrefijo,
      valor: Math.round(planPersonalizado.FoliosCantidad * planPersonalizado.ValorUnidadFolio)
    }).then(response => {
      if (response.status) {
        alert(response.msj);
      }
      setLoading(false);
    }, error => {
      console.log(error);
      setLoading(false);
    });
  };

  return (
    <>
      {<LoadingComponent Loading={loading} />}

      <Box component="form" onSubmit={(e) => crearPlanPersonalizado(e)}>
        <Paper variant="outlined" sx={{ m: 1, borderRadius: 2, overflow: 'hidden' }}>
          <Box sx={sectionTitleSx}>
            PLAN PERSONALIZADO
          </Box>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  label="Tipo de plan"
                  required
                  name="esNuevoPlanPadre"
                  autoComplete="off"
                  fullWidth
                  size="small"
                  onChange={(event) => onChangeValuePlan(event)}
                  sx={inputSx}
                >
                  <MenuItem value="" disabled>Seleccionar</MenuItem>
                  <MenuItem value={"true"}>Principal</MenuItem>
                  {ultimoPlanActivo && (
                    <MenuItem value={"false"}>Extensión</MenuItem>
                  )}
                </TextField>
              </Grid>

              {planPersonalizado.esNuevoPlanPadre && (
                <>
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Fecha Inicio"
                      type="date"
                      required
                      autoComplete="off"
                      name="FechaInicio"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={
                        planPersonalizado.esNuevoPlanPadre === "false"
                          ? moment(ultimoPlanActivo.finRenovacion)
                            .add(1, "days")
                            .format("yyyy-MM-DD")
                          : planPersonalizado.FechaInicio || ''
                      }
                      disabled={planPersonalizado.esNuevoPlanPadre === "false"}
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      select
                      label="Tipo de pago"
                      required
                      name="PagoAnual"
                      autoComplete="off"
                      fullWidth
                      size="small"
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    >
                      <MenuItem value="" disabled>Seleccionar</MenuItem>
                      <MenuItem value={"year"}>Anual</MenuItem>
                      <MenuItem value={"month"}>Mensual</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Folios Cantidad"
                      type="number"
                      required
                      autoComplete="off"
                      name="FoliosCantidad"
                      fullWidth
                      size="small"
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <NumericFormat
                      name="ValorUnidadFolio"
                      label="Valor Unidad Folio"
                      thousandSeparator=","
                      allowNegative={false}
                      customInput={TextField}
                      size="small"
                      required
                      autoComplete="off"
                      fullWidth
                      sx={inputSx}
                      onValueChange={(values) => {
                        onChangeValuePlan({
                          target: {
                            name: "ValorUnidadFolio",
                            value: values.value,
                          },
                        });
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <NumericFormat
                      label="Valor Total Plan Personalizado"
                      thousandSeparator=","
                      customInput={TextField}
                      size="small"
                      fullWidth
                      sx={inputSx}
                      value={
                        planPersonalizado.FoliosCantidad *
                        planPersonalizado.ValorUnidadFolio || 0
                      }
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Factura Prefijo"
                      inputProps={{ maxLength: 5 }}
                      type="text"
                      required
                      autoComplete="off"
                      name="FacturaPrefijo"
                      fullWidth
                      size="small"
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Factura Numero"
                      type="number"
                      required
                      autoComplete="off"
                      name="FacturaNumero"
                      fullWidth
                      size="small"
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Factura Fecha"
                      type="date"
                      required
                      autoComplete="off"
                      name="FacturaFecha"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      label="Observación plan personalizado"
                      type="text"
                      autoComplete="off"
                      name="Observacion"
                      fullWidth
                      size="small"
                      onChange={(event) => onChangeValuePlan(event)}
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                    <Box>
                      <Button
                        type="submit"
                        variant="contained"
                        size="small"
                        sx={{ background: '#224B6A', '&:hover': { background: '#1a3a54' }, fontSize: '0.78rem', mr: 1 }}
                      >
                        Guardar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ fontSize: '0.78rem' }}
                        onClick={() => closeWindow(false)}
                      >
                        Cancelar
                      </Button>
                    </Box>
                    <Button
                      type="button"
                      variant="contained"
                      color="warning"
                      size="small"
                      sx={{ fontSize: '0.78rem' }}
                      onClick={() => generarFactura()}
                    >
                      Generar factura
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default PlanPersonalizado;
